export const THEME_STORAGE_KEY = 'knov-theme'

export const persistAppearanceThemePreference = ({
    appearanceTheme,
    currentUser,
    lastPersistedThemeRef,
    persist,
}) => {
    if (!currentUser || lastPersistedThemeRef.current === appearanceTheme) return null

    lastPersistedThemeRef.current = appearanceTheme
    return persist({ theme: appearanceTheme })
}

export const resolveDocumentTheme = (dataTheme, systemPrefersDark = false) => {
    if (dataTheme === 'dark' || dataTheme?.endsWith('-dark')) return 'dark'
    if (dataTheme === 'light' || dataTheme?.endsWith('-light')) return 'light'

    return systemPrefersDark ? 'dark' : 'light'
}
